import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";
import { validatePassword } from "../../../utils/validation";

export const usePasswordUpdate = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { token } = useParams<{ token: string }>();

  const handleUpdatePassword = useCallback(
    (new_password: string, onError: () => void) => {
      if (!validatePassword(new_password)) return onError();

      if (!token) return;
      dispatch(appActions.showLoading());

      dispatch(
        authActions.updatePassword.started({
          token,
          new_password,
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: ({ success }) => {
            if (!success) navigateToPage(PageRoutes.LOGIN);
            else
              navigateToPage(PageRoutes.RESET_PASSWORD_COMPLETE, false, {
                token,
              });
          },
          onError: (error) => {
            dispatch(appActions.hideLoading());
            if (
              error?.response?.statusText === "password-reset-token-expired"
            ) {
              navigateToPage(PageRoutes.RESET_PASSWORD_TIMEOUT);
            }
          },
        }),
      );
    },
    [token],
  );

  return { handleUpdatePassword };
};
